module.exports = __webpack_public_path__ + "fonts/sms@2x.817c868f2c9b3a2eb00b7d82fdc16d5e.png?";


//////////////////
// WEBPACK FOOTER
// ./~/@okta/okta-signin-widget/dist/img/icons/mfa/sms@2x.png
// module id = 784
// module chunks = 9